import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/img/logo/footer-logo.png";
import footerBG from "../../assets/img/footer/footer-bg.jpg";

const Footer = (props) => {
  const { footerLogo, footerClass } = props;
  return (
    <footer>
      <div
        className={footerClass ? footerClass : "footer__area footer__plr"}
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-1">
                <div className="footer__logo">
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#FFDC60",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "800",
                        color: "#232323",
                        border: "2px solid white",
                      }}
                    >
                      AM
                    </div>
                    <span
                      style={{
                        fontSize: "1.6rem",
                        fontWeight: "700",
                        color: "white",
                      }}
                    >
                      Ayush Mishra
                    </span>
                  </Link>
                </div>
                <div className="footer__content">
                  <div className="footer__text">
                    <p>
                      I specialize in creating custom React and React Native
                      business applications that streamline operations, reduce
                      manual work, and boost efficiency for growing companies.
                    </p>
                  </div>
                  <div className="footer__number-wrapper d-flex align-items-center">
                    <div className="footer__number-icon">
                      <span>
                        <i className="fal fa-phone-alt"></i>
                      </span>
                    </div>
                    <div className="footer__number-info">
                      <span>Ready to Start Your Project?</span>
                      <a href="tel:+918802487352">+91 8802487352</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-2">
                <h4 className="footer__title">
                  <span>My Services</span>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <Link to="/projects">Inventory Management</Link>
                    </li>
                    <li>
                      <Link to="/projects">Employee Tracking</Link>
                    </li>
                    <li>
                      <Link to="/projects">Business Analytics</Link>
                    </li>
                    <li>
                      <Link to="/projects">Mobile App Development</Link>
                    </li>
                    <li>
                      <Link to="/projects">API Integration</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-3">
                <h4 className="footer__title">
                  <span>Quick Links</span>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about">About Me</Link>
                    </li>
                    <li>
                      <Link to="/projects">My Projects</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        LinkedIn Profile
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-7 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-4">
                <h4 className="footer__title">
                  <span>Get In Touch</span>
                </h4>
                <div className="footer__content">
                  <p>
                    Ready to transform your business operations? Let's discuss
                    your project requirements and create a solution that drives
                    real results.
                  </p>
                </div>

                {/* Contact Information */}
                <div
                  className="footer__contact-info"
                  style={{ marginBottom: "25px" }}
                >
                  <div
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="far fa-envelope"
                      style={{ color: "#FFDC60", fontSize: "16px" }}
                    ></i>
                    <a
                      href="mailto:ayushmishra7352@gmail.com"
                      style={{ color: "white", textDecoration: "none" }}
                    >
                      ayushmishra7352@gmail.com
                    </a>
                  </div>
                  <div
                    style={{
                      marginBottom: "15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt"
                      style={{ color: "#FFDC60", fontSize: "16px" }}
                    ></i>
                    <span style={{ color: "white" }}>Delhi, India</span>
                  </div>
                </div>

                <div className="footer__social-box">
                  <span>Connect With Me:</span>
                  <a
                    href="https://www.linkedin.com/in/ayush-mishra-526823280/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                  <a
                    href="https://github.com/IMshadow8802"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-github"></i>
                  </a>
                  <a href="mailto:ayushmishra7352@gmail.com">
                    <i className="far fa-envelope"></i>
                  </a>
                  <a href="tel:+918802487352">
                    <i className="fas fa-phone"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright__area copyright__plr black-bg-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-md-6 wow animate__slideInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__text">
                <span>© 2024 Ayush Mishra. All Rights Reserved.</span>
              </div>
            </div>
            <div
              className="col-md-6 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__item text-start text-md-end">
                <span>
                  <Link to="/">Home</Link>
                </span>
                <span>
                  <Link to="/projects">Projects</Link>
                </span>
                <span>
                  <Link to="/about">About</Link>
                </span>
                <span>
                  <Link to="/contact">Contact</Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
